import request from './request';
import deserialize from './deserialize';

export type SingleUseCodes = {
  id: string;
  code: string;
  deepLink: string;
};

interface GenerateAttrs {
  companyId: string;
  numOfStamps: number;
  storeId: string;
  slotNumber: number;
}

export function generate(attrs: GenerateAttrs) {
  const { companyId, storeId, numOfStamps, slotNumber } = attrs;

  return request<SingleUseCodes>({
    url: `/companion/v1/companies/${companyId}/stores/${storeId}/generate/su/code`,
    method: 'POST',
    data: {
      data: {
        attributes: {
          numOfStamps,
          slotNumber,
        },
      },
    },
    transformResponse: deserialize,
  });
}
